import React from 'react';
import { PROFESSIONS } from '../artistProfile';

export default function ProfessionFilters({ selected, onChange }) {
  const toggle = (profession) => onChange(selected.includes(profession)
    ? selected.filter((item) => item !== profession)
    : [...selected, profession]);

  return <div className="radius-options profession-filters" role="group" aria-label="Filter by profession or skill">
    <button type="button" className={!selected.length ? 'active' : ''} aria-pressed={!selected.length} onClick={() => onChange([])}>All</button>
    {PROFESSIONS.map((profession) => <button type="button" key={profession}
      className={selected.includes(profession) ? 'active' : ''}
      aria-pressed={selected.includes(profession)} onClick={() => toggle(profession)}>{profession}</button>)}
  </div>;
}
